import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideDefaultConfig } from '@spartacus/core';
import { SpecTableComponent } from './spec-table.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatExpansionModule,
    MatInputModule,
    I18nModule,
    SpecTableComponent,
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ProductSpecificationTableComponent: {
          component: SpecTableComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [SpecTableComponent],
})
export class SpecTableModule {}
